import React from 'react'
import * as S from './styles'
import SyncAltIcon from '@mui/icons-material/SyncAlt';

export default function InfoAction({ onClick, styleBox, styleIcon, ...props }) {
  return (
    <S.ActionBox onClick={onClick} style={styleBox} {...props}>
      <SyncAltIcon style={styleIcon} />
    </S.ActionBox>
  )
}
